import React from 'react'
import { FaLinkedin} from 'react-icons/fa';
import { GoRepo, GoMail, GoMarkGithub} from "react-icons/go";

const SocialLinks = () => {
    const links =[
        {
            id: 1,
            child:(
                <>
                LinkedIn <FaLinkedin  size={30} />
                </>
            ),
            href: 'https://www.linkedin.com/in/rochidzwa-chester/',
            style: "rounded-tr-md",

        },
        {
            id: 2,
            child:(
                <>
                GitHub <GoMarkGithub  size={30} />
                </>
            ),
            href: 'https://github.com/rotshidzw',
        },
        {
            id: 3,
            child:(
                <>
                Gmail <GoMail  size={30} />
                </>
            ),
            href: 'mailto:rochidzwachester@gmail.com',

        },
        {
            id: 4,
            child:(
                <>
                Resume <GoRepo  size={30} />
                </>
            ),
                href: "/rotshidzwa mavhungu chester Resume .pdf",
                style:"rounded-br-md",
                download:true,

        },

    ];
    return (
        <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
          <ul>
            {links.map(({ id, child, href, style, download }) => (
              <li
                key={id}
                className={
                  "flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-[#1d4ed8]" +
                  " " +
                  style
                }
              >
                <a
                  href={href}
                  className="flex justify-between items-center w-full text-white"
                  download={download}
                  target="_blank"
                  rel="noreferrer"
                >
                  {child}
                </a>
              </li>
            ))}
          </ul>
        </div>
      );
    };
    
    export default SocialLinks;